/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Animations
 */

module.exports = {

    Animation: require('./Animation'),
    AnimationFrame: require('./AnimationFrame'),
    AnimationManager: require('./AnimationManager')

};



//////////////////
// WEBPACK FOOTER
// ./animations/index.js
// module id = 464
// module chunks = 0